module.exports = __webpack_public_path__ + "img/rfid.f12f15e7.gif";